import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'velzon';

  constructor(private router: Router) {}

  navigateWithHash() {
    this.router.navigate(['visitor-home/:id'], { fragment: 'hash' });
  }
}
